export default __webpack_public_path__ + "images/plante_with_eye.e4099726.webp";